
// photo caption on home hero slider
$(document).ready(function(){
	$("button.photo-credit").click(function(){
		$("span.box").animate({
			width: "toggle"
		});
	});
});

// Hundred Percent Guarantee on Product Page
$(document).ready(function(){
  $(".guaranteeButton").click(function() {
  	$(".guaranteePanel").slideToggle("fast");
  	$(".guaranteeButton").toggleClass("active");
  });
});

// collection page filters
$(document).ready(function(){
if (document.body.classList.contains('desktop-only')) {
console.log("DESKTOP");
let Filters = document.getElementsByClassName("open-container-filter");
for (var i = 0; i < Filters.length; i++) {
  console.log("found filter");
  let details = Filters.item(i).querySelector("details");
  details.addEventListener("toggle", function() {
	console.log("clicked detail");
	details.querySelector("summary").classList.toggle("active");
  });
}
}
});


// Product Info Accordions
$(document).ready(function(){
$(".featuresButton").click(function(e) {
	e.preventDefault();
	$(".featuresPanel").slideToggle("fast");
	$(".featuresButton").toggleClass("active");
});
});

$(document).ready(function(){
$(".specsButton").click(function(e) {
	e.preventDefault();
	$(".specsPanel").slideToggle("fast");
	$(".specsButton").toggleClass("active");
});
});

$(document).ready(function(){
$(".materialsButton").click(function(e) {
	e.preventDefault();
	$(".materialsPanel").slideToggle("fast");
	$(".materialsButton").toggleClass("active");
});
});

$(document).ready(function(){
$(".careButton").click(function(e) {
	e.preventDefault();
	$(".carePanel").slideToggle("fast");
	$(".careButton").toggleClass("active");
});
});

$(document).ready(function(){
$(".setupButton").click(function(e) {
	e.preventDefault();
	$(".setupPanel").slideToggle("fast");
	$(".setupButton").toggleClass("active");
});
});


$(document).ready(function(){
$(".reviewsButton").click(function(e) {
	e.preventDefault();
	$(".reviewsPanel").slideToggle("fast");
	$(".reviewsButton").toggleClass("active");
});
});

// Page Section Accordions
$(document).ready(function(){
$(".pageButton-html").click(function() {
	$(".pagePanel-html").slideToggle("fast");
	$(".pageButton-html").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-1").click(function() {
	$(".pagePanel-1").slideToggle("fast");
	$(".pageButton-1").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-2").click(function() {
	$(".pagePanel-2").slideToggle("fast");
	$(".pageButton-2").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-3").click(function() {
	$(".pagePanel-3").slideToggle("fast");
	$(".pageButton-3").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-4").click(function() {
	$(".pagePanel-4").slideToggle("fast");
	$(".pageButton-4").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-5").click(function() {
	$(".pagePanel-5").slideToggle("fast");
	$(".pageButton-5").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-6").click(function() {
	$(".pagePanel-6").slideToggle("fast");
	$(".pageButton-6").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-7").click(function() {
	$(".pagePanel-7").slideToggle("fast");
	$(".pageButton-7").toggleClass("active");
});
});

$(document).ready(function(){
$(".pageButton-8").click(function() {
	$(".pagePanel-8").slideToggle("fast");
	$(".pageButton-8").toggleClass("active");
});
});


$(document).ready(function(){
$(".pageButton-omni").click(function () {
	$(this).next(".pagePanel-omni").slideToggle("fast");
	$(this).closest(".pageButton-omni").toggleClass("active");
});
});


$(document).ready(function(){
$(".collection-info-button-1").click(function() {
	$(".collection-info-panel-1").slideToggle("fast");
	$(".collection-info-button-1").toggleClass("active");
});
});

$(document).ready(function(){
$(".collection-info-button-2").click(function() {
	$(".collection-info-panel-2").slideToggle("fast");
	$(".collection-info-button-2").toggleClass("active");
});
});

$(document).ready(function(){
$(".collection-info-button-3").click(function() {
	$(".collection-info-panel-3").slideToggle("fast");
	$(".collection-info-button-3").toggleClass("active");
});
});

$(document).ready(function(){
$(".collection-info-button-4").click(function() {
	$(".collection-info-panel-4").slideToggle("fast");
	$(".collection-info-button-4").toggleClass("active");
});
});

$(document).ready(function(){
$(".collection-info-button-5").click(function() {
	$(".collection-info-panel-5").slideToggle("fast");
	$(".collection-info-button-5").toggleClass("active");
});
});



$(document).ready(function(){
  // bind change event to select
  $('.store_select').on('change', function () {
	console.log("working");
	  var url = $(this).val(); // get selected value
	  if (url) { // require a URL
		  window.location = url; // redirect
	  }
	  return false;
  });
});

// // Hide Bazaarvoice Rating Summary and Inline Rating if 0 reviews
// $(document).ready(function() {
//   // Function to check and hide
//   function checkBVZeroReviews(element) {
//     var $el = $(element);
//     // Avoid re-checking if we already hid it
//     if ($el.is(':hidden') || $el.closest('.reviews').is(':hidden')) return;

//     // Check if BV has rendered something
//     // The user provided HTML shows .bv_main_rating_button, .bv_ratings_summary, or .bv_main_container
//     if ($el.find('.bv_main_rating_button').length > 0 || $el.find('.bv_ratings_summary').length > 0 || $el.find('.bv_main_container').length > 0 || $el.text().trim().length > 0) {
//         var text = $el.text();
//         var hasZero = false;
        
//         // Check for specific text patterns in the entire element text
//         if (text.indexOf('(0)') !== -1) hasZero = true;
        
//         // Check text inside bv_numReviews_text specifically (Example 1)
//         var $numReviews = $el.find('.bv_numReviews_text');
//         if ($numReviews.length > 0) {
//             var numText = $numReviews.text().trim();
//             if (numText === '(0)' || numText === '0') hasZero = true;
//         }

//         // Check text inside .bv_numReviews_component_container .bv_text (Example 2)
//         var $numReviews2 = $el.find('.bv_numReviews_component_container .bv_text');
//         if ($numReviews2.length > 0) {
//              var numText2 = $numReviews2.text().trim();
//              if (numText2 === '(0)' || numText2 === '0') hasZero = true;
//         }

//         // Check offscreen text for "No rating value" (Example 1)
//         var $offscreen = $el.find('.bv_offscreen_text');
//         if ($offscreen.length > 0 && $offscreen.text().indexOf('No rating value') !== -1) {
//              hasZero = true;
//         }
        
//         // Check aria-label on .bv_main_container (Example 2)
//         var $mainContainer = $el.find('.bv_main_container');
//         if ($mainContainer.length > 0) {
//             var ariaLabel = $mainContainer.attr('aria-label');
//             if (ariaLabel && ariaLabel.trim().indexOf('0.0') === 0) {
//                 hasZero = true;
//             }
//         }

//         if (hasZero) {
//             $el.hide();
//             // Also hide the wrapper div to remove spacing
//             $el.closest('.reviews').hide();
//         }
//     }
//   }

//   // Observe the body for changes (Bazaarvoice renders asynchronously)
//   var observer = new MutationObserver(function(mutations) {
//      $('[data-bv-show="rating_summary"], [data-bv-show="inline_rating"]').each(function() {
//          checkBVZeroReviews(this);
//      });
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });

//Store language selector open
$(document).ready(function(){
	$(".store_select_popout").click(function() {
		//if mobile menue is open, open mobile menu langauge picker
		if ( document.querySelector(".toggleMenu").classList.contains("isMobile") && document.querySelector(".toggleMenu").classList.contains("active") ) {
			$(".site-switcher-popout-modal-mobile").slideToggle("fast");
			//close rest of menu items when site switcher is clicked
			document.querySelector('.responsiveMenu').querySelectorAll('li.hover').forEach(function(r) {
				r.classList.remove('hover');
				r.querySelector('a.parent').setAttribute('aria-expanded','false');
			});
		} else {
			//else open normal langauge picker
			$(".site-switcher-popout-modal-desktop").slideToggle("fast");
			//close rest of menu items when site switcher is clicked
			document.querySelector('.responsiveMenu').querySelectorAll('li.hover').forEach(function(r) {
				r.classList.remove('hover');
				r.querySelector('a.parent').setAttribute('aria-expanded','false');
			});
		}
	});
});

//Store language selector close
$(document).ready(function(){  
	$(".site-switcher-popout-close-desktop").click(function() {
	  $(".site-switcher-popout-modal-desktop").slideToggle("fast");
	});
  });
$(document).ready(function(){  
$(".site-switcher-popout-close-mobile").click(function() {
	$(".site-switcher-popout-modal-mobile").slideToggle("fast");
});
});

//close if clicked outside language selector
$(document).ready(function(){
  $(document).click(function(){
	$(".store_select_popout_modal").click(function(e){
		e.stopPropagation();
	});
	$(".store_select_popout").click(function(e){
		e.stopPropagation();
	});
    if ( !$(".site-switcher-popout-modal-desktop" ).hasClass('unclicked') ) {
        $(".site-switcher-popout-modal-desktop").toggleClass("hidden");
        $(".site-switcher-popout-modal-desktop").slideUp("fast");
    }
    $(".site-switcher-popout-modal-desktop").removeClass("unclicked");
    if ( !$(".site-switcher-popout-modal-mobile" ).hasClass('unclicked') ) {
        $(".site-switcher-popout-modal-mobile").toggleClass("hidden");
        $(".site-switcher-popout-modal-mobile").slideUp("fast");
    }
    $(".site-switcher-popout-modal-mobile").removeClass("unclicked");
  });
});

//ADD "CAD" in front of prices in checkout
$(document).ready(function(){
	let checkout_total_price = document.getElementById("total-cart-bottom");
	if ( checkout_total_price ) {
		checkout_total_price.innerHTML = "CAD " + checkout_total_price.innerHTML;
	}
	let checkout_individual_prices_parent = document.querySelector(".cart-table");
	if ( checkout_individual_prices_parent ) {
		let checkout_individual_prices =  checkout_individual_prices_parent.getElementsByClassName("total-price-item");
		if ( checkout_individual_prices.length > 0 ) {
			for (let i = 0; i < checkout_individual_prices.length; i++) {
				checkout_individual_prices[i].innerHTML = "CAD " + checkout_individual_prices[i].innerHTML;
			}
		}
		let checkout_individual_prices_sale =  checkout_individual_prices_parent.getElementsByClassName("total-sale-item");
		if ( checkout_individual_prices_sale.length > 0 ) {
			for (let i = 0; i < checkout_individual_prices_sale.length; i++) {
				checkout_individual_prices_sale[i].innerHTML = "CAD " + checkout_individual_prices_sale[i].innerHTML;
			}
		}
	}
});

//style EU, EN Osano banner
window.Osano('onUiChanged', (component, stateChange) => {
	if (component === 'dialog' && stateChange === 'show') {
		let osanoBanner = document.querySelector('.osano-cm-window__dialog');
		let euCountries = ["locale-ca", "locale-be", "locale-bg", "locale-hr", "locale-cy", "locale-cz", "locale-dk", "locale-ee", "locale-fi", "locale-fr", "locale-de", "locale-gr", "locale-hu", "locale-ie", "locale-it", "locale-lv", "locale-lt", "locale-lu", "locale-mt", "locale-nl", "locale-pl", "locale-pt", "locale-ro", "locale-sk", "locale-si", "locale-es", "locale-se", "locale-gb"];

		// Check if in the EU
		let isEUCountry = euCountries.some(className => osanoBanner.classList.contains(className));

		// Check if banner is in English
		let isEnglishBanner = osanoBanner.classList.contains("language-en");

		if (isEnglishBanner && isEUCountry) {
		modifyBanner("eu", "en");
		}
	}
});
  
function modifyBanner(osanoLocale, osanoLanguage) {
	let osanoList = document.querySelector('.osano-cm-dialog__list');
	let osanoButtons = document.querySelector('.osano-cm-dialog__buttons');
	let osanoText = document.querySelector('.osano-cm-dialog__content');
	let newParent = document.createElement('div');
	if (osanoList && osanoButtons) {
		osanoButtons.parentNode.insertBefore(newParent, osanoButtons);
		newParent.appendChild(osanoText);
		newParent.appendChild(osanoList);
	}
	// modify text of the Osano banner

	// Get the span element containing the osano message
	let osanoContentMessage = document.querySelector(".osano-cm-content__message");
	// Get the text content of the span
	let text = osanoContentMessage.innerHTML;
	// Split the text at every occurrence of `<!--`
	if (typeof textParts == 'undefined') {
		let textParts = text.split(/<!--/);
		//clear out span element innerhtml
		osanoContentMessage.innerHTML = '';
		//if the text hasn't yet been parsed, parse it
		if (textParts.length > 1) {
			// Create a new paragraph element for each text part
			textParts.forEach((part, index) => {
				let part2 = part.split(/-->/);
				// Skip the first part since it's before the first `<!--`
				if (index !== 0) {
					// Create a new paragraph element
					let paragraph = document.createElement("p");
					// Set the text content of the paragraph
					paragraph.textContent = part2[1];
					//add class if the paragraph should be small
					if (index !== 1) {
						paragraph.classList.add("osano-small-text")
					}
					// Append the paragraph to the parent element
					osanoContentMessage.appendChild(paragraph);
				}
			});
		} else {
			osanoContentMessage.innerHTML = textParts[0];
		}
	} else {
		osanoContentMessage.innerHTML = textParts[0];
	}
}

//handle language/region selector

$(document).ready(function () {
	let country_selects = document.getElementsByClassName("country-options-list");
	let language_selects = document.getElementsByClassName("language-menu");
	Array.from(country_selects).forEach(element => {});
	Array.from(country_selects).forEach(function (country_select, i) {
		let selection = country_select.selectedIndex;
		setTimeout(function () {

			let currentSubdomain = window.location.href.slice(0, window.location.href.indexOf(".bigagnes")).slice(8);
			var currentURL = window.location.href;
			let currentLanguage = currentURL.substring(currentURL.indexOf(".com/") + 5, currentURL.indexOf(".com/") + 7);

			language_selects[i].innerHTML = '<option value="https://ca.bigagnes.com/">English</option><option value="https://ca.bigagnes.com/fr">French</option>';
            country_select.value = "Canada";

			if (currentLanguage == "fr") {
				language_selects[i].value = "https://ca.bigagnes.com/fr";
			} else {
				language_selects[i].value = "https://ca.bigagnes.com/";
			}

			//Set variables for heading country, flag, and currency
			let headingFlag = "https://cdn.shopify.com/s/files/1/0715/3205/2801/files/canada-flag.png";
			let headingFlagAlt = "Canadian flag";
			let headingCountry = "Canada";
			let headingCurrency = "CAD";

			//Get variables for heading language
			let headingLanguage = '';
			if (currentLanguage == "de") {
				headingLanguage = "DE";
			} else if (currentLanguage == "fr") {
				headingLanguage = "FR";
			} else if (currentLanguage == "it") {
				headingLanguage = "IT";
			} else if (currentLanguage == "nl") {
				headingLanguage = "NL";
			} else if (currentLanguage == "es") {
				headingLanguage = "ES";
			} else {
				headingLanguage = "EN";
			}

			//populate heading
			console.log(headingCountry, headingCurrency, headingFlag, headingFlagAlt, headingLanguage);
			Array.from(document.getElementsByClassName("country-selector-heading")).forEach(heading => {
				heading.innerHTML = headingFlag ? "<img src=" + headingFlag + " alt=" + headingFlagAlt + ">" + headingCountry + " | " + headingLanguage : headingLanguage;
			});
		}, 200);

		country_select.addEventListener(
			'change',
			function () {
              console.log("changed");
				//populate correct language options based on selection
				selection = country_select.selectedIndex;
				if (selection == 0 || selection == 1 || selection == 2 || selection == 3 || selection == 4 || selection == 5 || selection == 6) {
					if (language_selects[i].innerHTML !== '<option value="https://eu.bigagnes.com/">English</option><option value="https://eu.bigagnes.com/de">German</option><option value="https://eu.bigagnes.com/it">Italian</option><option value="https://eu.bigagnes.com/nl">Dutch</option><option value="https://eu.bigagnes.com/es">Spanish</option><option value="https://eu.bigagnes.com/fr">French</option>') {
						language_selects[i].innerHTML = '<option value="https://eu.bigagnes.com/">English</option><option value="https://eu.bigagnes.com/de">German</option><option value="https://eu.bigagnes.com/it">Italian</option><option value="https://eu.bigagnes.com/nl">Dutch</option><option value="https://eu.bigagnes.com/es">Spanish</option><option value="https://eu.bigagnes.com/fr">French</option>';
					}
				} else if (selection == 7) {
					if (language_selects[i].innerHTML !== '<option value="https://ca.bigagnes.com/">English</option><option value="https://ca.bigagnes.com/fr">French</option>') {
						language_selects[i].innerHTML = '<option value="https://ca.bigagnes.com/">English</option><option value="https://ca.bigagnes.com/fr">French</option>';
					}
				} else if (selection == 8) {
					if (language_selects[i].innerHTML !== '<option value="https://bigagnes.com/">English</option>') {
						language_selects[i].innerHTML = '<option value="https://bigagnes.com/">English</option>';
					}
				}
			},
			false
		);
	});
    //handle click of language select button
    let languageSelectButtonDesktop = document.querySelector(".language-select-submit-button-desktop");
    let languageSelectButtonMobile = document.querySelector(".language-select-submit-button-mobile");
    languageSelectButtonDesktop.addEventListener(
        'click',
        function () {
            let selectedLanguage = '';
            if ($(this).closest(".country-selector-list").find(".language-menu-desktop")[0].selectedIndex !== -1) {
                selectedLanguage = $(this).closest(".country-selector-list").find(".language-menu-desktop")[0].options[$(this).closest(".country-selector-list").find(".language-menu-desktop")[0].selectedIndex].value;
            }
            let selectedCountry = '';
            if ($(this).closest(".country-selector-list").find(".country-options-list-desktop")[0].selectedIndex !== -1) {
                selectedCountry = $(this).closest(".country-selector-list").find(".country-options-list-desktop")[0].options[$(this).closest(".country-selector-list").find(".country-options-list")[0].selectedIndex].value;
            }

            document.cookie = "country=" + selectedCountry + ";domain=bigagnes.com;path=/";
            document.cookie = "language=" + $(this).closest(".country-selector-list").find(".language-menu-desktop")[0][$(this).closest(".country-selector-list").find(".language-menu-desktop")[0].selectedIndex].text + ";domain=bigagnes.com;";
            let current_page = window.location.href.split('bigagnes.com/')[1];
            let langCheck = /^(es|it|de|fr|nl)/;
            var langCheckResult = langCheck.test(current_page.substring(0, 2));
            //if currently on a language subdomain, replace with new lang
            if (langCheckResult) {
              if ( selectedLanguage[selectedLanguage.length - 1] !== "/" ) {
                window.open(selectedLanguage + current_page.substring(2), "_self");
              } else {
                window.open(selectedLanguage + current_page.substring(3), "_self");
              }
            //else open new lang with no replace
            } else {
              if ( selectedLanguage[selectedLanguage.length - 1] !== "/" ) {
                window.open(selectedLanguage + "/" + current_page, "_self");
              } else {
                window.open(selectedLanguage + current_page, "_self");
              }
            }
        },
        false
    );
    languageSelectButtonMobile.addEventListener(
      'click',
      function () {
          let selectedLanguage = '';
          if ($(this).closest(".country-selector-list").find(".language-menu-mobile")[0].selectedIndex !== -1) {
              selectedLanguage = $(this).closest(".country-selector-list").find(".language-menu-mobile")[0].options[$(this).closest(".country-selector-list").find(".language-menu-mobile")[0].selectedIndex].value;
          }
          let selectedCountry = '';
          if ($(this).closest(".country-selector-list").find(".country-options-list-mobile")[0].selectedIndex !== -1) {
              selectedCountry = $(this).closest(".country-selector-list").find(".country-options-list-mobile")[0].options[$(this).closest(".country-selector-list").find(".country-options-list")[0].selectedIndex].value;
          }

          document.cookie = "country=" + selectedCountry + ";domain=bigagnes.com;path=/";
          document.cookie = "language=" + $(this).closest(".country-selector-list").find(".language-menu-mobile")[0][$(this).closest(".country-selector-list").find(".language-menu-mobile")[0].selectedIndex].text + ";domain=bigagnes.com;";
          let current_page = window.location.href.split('bigagnes.com/')[1];
          let langCheck = /^(es|it|de|fr|nl)/;
          var langCheckResult = langCheck.test(current_page.substring(0, 2));
          //if currently on a language subdomain, replace with new lang
          if (langCheckResult) {
            if ( selectedLanguage[selectedLanguage.length - 1] !== "/" ) {
              window.open(selectedLanguage + current_page.substring(2), "_self");
            } else {
              window.open(selectedLanguage + current_page.substring(3), "_self");
            }
          //else open new lang with no replace
          } else {
            if ( selectedLanguage[selectedLanguage.length - 1] !== "/" ) {
              window.open(selectedLanguage + "/" + current_page, "_self");
            } else {
              window.open(selectedLanguage + current_page, "_self");
            }
          }
      },
      false
  );
});

//open cookie preferences banner on footer link click
document.addEventListener('DOMContentLoaded', function() {
    const cookieLink = document.querySelector('#menu-footer-1 a[title="Cookie Preferences"]');
    
    if (cookieLink) {
        cookieLink.addEventListener('click', function(event) {
            event.preventDefault();
            if (window.Osano && window.Osano.cm) {
                window.Osano.cm.showDrawer('preferences');
            } else {
                console.error("Osano is not loaded");
            }
        });
    }
});

// Bazaarvoice Rating Summary Click Handler
$(document).ready(function() {
  $('body').on('click', '.bv_modal_component_container button, .bv_stars_component_container, .bv_stars_component_container button', function() {
    // Check if the reviews panel is hidden
    if (!$('.reviewsPanel').is(':visible')) {
      $('.reviewsButton').click();
    }
    
    // Scroll to the reviews button/panel
    // Using a small timeout to allow for any immediate DOM updates (though slideToggle is async)
    setTimeout(function() {
        if ($(".reviewsButton").length) {
            $('html, body').animate({
              scrollTop: $(".reviewsButton").offset().top - 100
            }, 500);
        }
    }, 100);
  });
});
